import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { CheckInDataService } from 'projects/Check-In/src/app/Services/check-in-data.service';
import { checkInKeys, localStorageKeys } from '../../../../Models/configurations';
import { SecureStorageService } from '../../../../Services/secure-storage.service';
import { CultureLocaleService } from 'projects/Check-In/src/app/Services/culture-locale.service';
import { ClientAppLogin } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-lp-authentication',
  templateUrl: './lp-authentication.component.html'
})
export class LpAuthenticationComponent implements OnInit {
  name: string;
  validLpNumber: string;
  errormessage: string;
  constructor(
    private activeModal: NgbActiveModal,
    private readonly secureStorageService: SecureStorageService,
    private translate: TranslateService,
    private checkInDataService: CheckInDataService,
    private cultureLocaleService: CultureLocaleService
  ) { }

  ngOnInit(): void {
    // This is intentional

    // Task 8584: MG : MinBil : Direct bypass for minbil user for checkin & tracker url
    // this is done for MG - where the licenceplate is filled & validated automatically.
    let autoCarPlate = this.secureStorageService.getKeyData(localStorageKeys.autoCarPlate);
    if (autoCarPlate) {
      this.name = autoCarPlate;
      this.onOK();
    }
  }

  async onOK() {
    if (isNullOrUndefined(this.name)) {
      this.errormessage = this.translate.instant("lblLiscencePlateError");
    } else {
      this.secureStorageService.removeStringKeyArray([checkInKeys.CheckIn,localStorageKeys.checkingModule]);
      const RequestParam = {
        checkInTinyUrl: this.secureStorageService.getKeyData(localStorageKeys.tinyUrl),
        lpNumber: this.name.toLowerCase().replace(/\s/g, "")
      }
      await this.checkInDataService.DecryptTinyUrl(RequestParam)
        .subscribe(async (res: any) => {
          if (!isNullOrUndefined(res?.token) && res?.token != "") {
            ClientAppLogin(res.token);
            this.secureStorageService.setKeyData(checkInKeys.CheckIn, res.data);
            await this.cultureLocaleService.initialise();
            this.callResetAppointment(this.name.toLowerCase().replace(/\s/g, ""));
          } else {
            this.callResetAppointment(null);
          }
        },
          (_err: HttpErrorResponse) => {
            this.name = '';
            this.errormessage = this.translate.instant("lblLiscencePlateError");
          })
    }
  }

  callResetAppointment(_name) {
    // DON'T Delete the mthod used in Parent
  }

  closeModal() {
    this.activeModal.close();
  }
}
